import { render } from "./AgreementPage.vue?vue&type=template&id=0619fc88&scoped=true"
import script from "./AgreementPage.vue?vue&type=script&lang=js"
export * from "./AgreementPage.vue?vue&type=script&lang=js"

import "./AgreementPage.vue?vue&type=style&index=0&id=0619fc88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0619fc88"]])

export default __exports__